'use client'

import { PropsWithChildren } from 'react'
import styles from './CustomModal.module.css'
import { createPortal } from 'react-dom'
import { ModalTypes } from '@/interfaces/api/generic/api_modals_types'
import ModalCard from '@/components/UI/Card/ModalCard/ModalCard'

interface ModalProps extends React.HTMLAttributes<HTMLDivElement> {
  type: ModalTypes
	closeOnBackdrop: boolean
	onClose: () => void
}

export default function CustomModal({ type, closeOnBackdrop, onClose, className, children, ...rest }: PropsWithChildren<ModalProps>) {
	/**
	 * Handle click on backdrop element
	 * 
	 * Close the modal
	 */
	function handleClickOnBackdrop () {
		if(closeOnBackdrop) onClose()
	}
	
	return createPortal(
		<div
			className={`${styles.modal} ${type ?? ''} ${className ?? ''}`}
			{...rest}
			data-testid="CustomModal"
		>
			<div
				className={styles.backdrop}
				onClick={handleClickOnBackdrop}
			/>

			<ModalCard type={type} className={styles.dialog} onClose={onClose}>
				{children}
			</ModalCard>
		</div>,
		document.body
	)
}